// TurnstileLoader.jsx
import React, { useEffect, useRef, memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import {
  TURNSTILE_CONTAINER_ID,
  initTurnstile,
} from '../resource/turnstile.js';

const DELAY_LOADING_MSEC = 10000; // TODO: remote config
const listenEvents = ['mousemove', 'scroll', 'click'];

export const TurnstileLoader = ({ turnstileSiteKey = '' }) => {
  const idleCallback = useRef();
  const timeout = useRef();

  const loadTurnstile = async () => {
    clearSideEffects();
    if (turnstileSiteKey) await initTurnstile({ sitekey: turnstileSiteKey });
  };

  const initTimeout = () => {
    timeout.current = setTimeout(loadTurnstile, DELAY_LOADING_MSEC);
  };

  const clearSideEffects = () => {
    listenEvents.forEach(event => {
      document.removeEventListener(event, loadTurnstile);
    });
    cancelIdleCallback(idleCallback.current);
    clearTimeout(timeout.current);
  };

  useEffect(() => {
    idleCallback.current = requestIdleCallback(initTimeout);
    listenEvents.forEach(event => {
      document.addEventListener(event, loadTurnstile);
    });

    return () => {
      clearSideEffects();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <StyledTurnstileLoader id={TURNSTILE_CONTAINER_ID} />;
};

TurnstileLoader.propTypes = {
  turnstileSiteKey: PropTypes.string,
};

const StyledTurnstileLoader = styled.div`
  width: 0;
  height: 0;
`;

export default memo(TurnstileLoader);
